import { BubbleFactory, regularColors } from 'js/bubbleCore/bubbles/BubbleFactory';
import { convertHexLimitsToSpaceLimits } from 'js/bubbleCore/utils/convertHexLimitsToSpaceLimits';
import { convertRectangleToSpace } from 'js/bubbleCore/utils/convertRectangleToSpace';
import { IShooterData } from 'js/bubbleCore/types';
import { ILevelData } from 'js/bubbleCore/levelParser/parseLevel';
import { deg2rad } from 'framework/utils/math-utils';

export function parseShooter(factory: BubbleFactory, levelData: ILevelData): IShooterData {
  const type = levelData.grid.type;
  const spaceLimits = convertRectangleToSpace(
    convertHexLimitsToSpaceLimits(levelData.grid.hexLimits, type)
  );

  const colors = regularColors.slice(0, levelData.config.availableColors[0].colors);

  return {
    position: {x: spaceLimits.right * 0.5, y: levelData.shooter.positionY},
    bubbleSpeed: levelData.shooter.bubbleSpeed,
    bubblesQueue: [
      factory.createRegular(0, 0, colors),
      factory.createRegular(0, 0, colors),
    ],
    angleLimitRad: deg2rad(levelData.shooter.angleLimitDeg),
  };
}